/* tslint:disable */
/* eslint-disable */
/**
 * Lemonway DirectKit API 2.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MoneyInMultibancoInitInput
 */
export interface MoneyInMultibancoInitInput {
    /**
     * 
     * @type {string}
     * @memberof MoneyInMultibancoInitInput
     */
    startDate?: string;
    /**
     * 
     * @type {string}
     * @memberof MoneyInMultibancoInitInput
     */
    endDate?: string;
    /**
     * Your site returns the URL, called to terminate the operation and on which the callback will be sent, with data in POST parameters.
     * This URL must contain a unique ID so you know which operation is related to the return.
     * @type {string}
     * @memberof MoneyInMultibancoInitInput
     */
    returnUrl: string;
    /**
     * Unique ID of the call, generated by your server. This ID can be used as a search field when looking for operation details
     * @type {string}
     * @memberof MoneyInMultibancoInitInput
     */
    reference?: string;
    /**
     * Payment Account ID to Credit
     * @type {string}
     * @memberof MoneyInMultibancoInitInput
     */
    accountId: string;
    /**
     * Amount to Debit
     * Amounts are given as integer numbers in cents
     * @type {number}
     * @memberof MoneyInMultibancoInitInput
     */
    totalAmount?: number;
    /**
     * Your Fee
     * Amounts are given as integer numbers in cents
     * @type {number}
     * @memberof MoneyInMultibancoInitInput
     */
    commissionAmount?: number;
    /**
     * Comment Regarding the Transaction
     * @type {string}
     * @memberof MoneyInMultibancoInitInput
     */
    comment?: string;
    /**
     * If true:
     * 1. [amountCom] will be ignored and will be replaced with Lemonway's fee
     * 2. You will not receive any fee
     * @type {boolean}
     * @memberof MoneyInMultibancoInitInput
     */
    autoCommission?: boolean;
}

/**
 * Check if a given object implements the MoneyInMultibancoInitInput interface.
 */
export function instanceOfMoneyInMultibancoInitInput(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "returnUrl" in value;
    isInstance = isInstance && "accountId" in value;

    return isInstance;
}

export function MoneyInMultibancoInitInputFromJSON(json: any): MoneyInMultibancoInitInput {
    return MoneyInMultibancoInitInputFromJSONTyped(json, false);
}

export function MoneyInMultibancoInitInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): MoneyInMultibancoInitInput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'startDate': !exists(json, 'startDate') ? undefined : json['startDate'],
        'endDate': !exists(json, 'endDate') ? undefined : json['endDate'],
        'returnUrl': json['returnUrl'],
        'reference': !exists(json, 'reference') ? undefined : json['reference'],
        'accountId': json['accountId'],
        'totalAmount': !exists(json, 'totalAmount') ? undefined : json['totalAmount'],
        'commissionAmount': !exists(json, 'commissionAmount') ? undefined : json['commissionAmount'],
        'comment': !exists(json, 'comment') ? undefined : json['comment'],
        'autoCommission': !exists(json, 'autoCommission') ? undefined : json['autoCommission'],
    };
}

export function MoneyInMultibancoInitInputToJSON(value?: MoneyInMultibancoInitInput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'startDate': value.startDate,
        'endDate': value.endDate,
        'returnUrl': value.returnUrl,
        'reference': value.reference,
        'accountId': value.accountId,
        'totalAmount': value.totalAmount,
        'commissionAmount': value.commissionAmount,
        'comment': value.comment,
        'autoCommission': value.autoCommission,
    };
}

